/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusObjektDetailDto } from '../../models/lexplus-objekt-detail-dto';

export interface ObjekteControllerFindOneDetailsByIdV1$Params {
  id: number;
}

export function objekteControllerFindOneDetailsByIdV1(http: HttpClient, rootUrl: string, params: ObjekteControllerFindOneDetailsByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusObjektDetailDto>> {
  const rb = new RequestBuilder(rootUrl, objekteControllerFindOneDetailsByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusObjektDetailDto>;
    })
  );
}

objekteControllerFindOneDetailsByIdV1.PATH = '/v1/objekte/details/{id}';
